import { useEffect, useState } from "react";

function BrowserNotifications() {
    const [showNotification, setShowNotification] = useState(null);
    useEffect(() => {
        if (!("Notification" in window)) {
            console.log("Browser does not support desktop notification");
        } else {
            Notification.requestPermission();
        }
    }, []);

    const notificationTest = (event) => {
        new Notification('Hello World')
    };

    //TODO: add something here 
    return (
        <div></div>
    );
}

export default BrowserNotifications;